import cx from "classnames";
import { Button } from "common/Button";
import { GlobalFooter } from "common/GlobalFooter";
import { LoginModalOverlay } from "common/styleguide/LoginModalOverlay";
import { TwoTierNav } from "common/TwoTierNav";
import React from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import appStyles from "../../App/appStyles.scss";
import { rrSubnav } from "../../IndexPage";
import commonStyles from "../common.scss";
import styles from "./RolloutConfirmedPage.scss";

const imagePath = "/images/ride_reports_rollout/";

export class RolloutConfirmedPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showSignInModal: false };
  }

  showSignInModal = () => this.setState({ showSignInModal: true });

  hideSignInModal = () => this.setState({ showSignInModal: false });

  render() {
    const { showSignInModal } = this.state;
    return (
      <div className={cx(styles.RolloutConfirmedPage, commonStyles.Page, appStyles.base)}>
        <Helmet title="Ride Reports · Contest Info" />
        {showSignInModal && (
          <LoginModalOverlay onRequestClose={this.hideSignInModal} redirectTo={"/ride_reports/new"} />
        )}
        <TwoTierNav
          secondaryNav={rrSubnav({
            currentUser: this.props.currentUser,
            draftCount: this.props.draftCount,
          })}
        />
        <header>
          <div className={styles.headerImage}>
            <img src={`${imagePath}rr_logo_3.png`} />
          </div>
          <div className={styles.headerDetails}>
            <div className={styles.headerDetailsInner}>
              <h2>You're In!</h2>
              <p>
                We are happy to have you as a participant in the Ride Report Rollout. The best part? Your next steps are
                actually fun! All you need to do is go on a ride between March 1st and May 1st, then create and submit a
                great report by May 1st. View some helpful information below, including a video. If you need help at
                anytime, don't hesitate to email us, we'll get back to you within 12 hours.
              </p>
              <p>
                <a href="mailto:info@ridewithgps.com">info@ridewithgps.com</a>
              </p>
              {window.rwgps.config.currentUser ? (
                <Link to="/ride_reports/new">
                  <Button className={cx(commonStyles.primaryButton, styles.headerButton)}>Create Report</Button>
                </Link>
              ) : (
                <a href="#" onClick={this.showSignInModal}>
                  <Button className={cx(commonStyles.primaryButton, styles.headerButton)}>Create Report</Button>
                </a>
              )}
              <h3>Download the Ride with GPS app</h3>
              <a
                href="https://itunes.apple.com/us/app/ride-with-gps-bike-computer/id893687399?ls=1&mt=8"
                target="_blank"
              >
                <img src={`${imagePath}app_store.png`} />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.ridewithgps.mobile" target="_blank">
                <img src={`${imagePath}play-badge.png`} />
              </a>
            </div>
          </div>
        </header>
        <main>
          <section className={styles.howTo}>
            <h2>How to Create a Rad Report</h2>
            <p>
              The process is simple - Go on a ride, record it, take photos along the way, then create a Ride Report that
              tells the story. We recommend watching the quick video below to get an overview of how easy it is to tell
              your own story using Ride Reports.
            </p>
            <a href="https://www.youtube.com/watch?v=PrWtJyIdHU0">
              <img src={`${imagePath}play.png`} />
              Watch the Video
            </a>
          </section>
          <section className={styles.steps}>
            <div className={styles.step}>
              <div className={styles.stepNumber}>01</div>
              <div className={styles.stepImage}>
                <img src={`${imagePath}step-1.png`} />
              </div>
              <h3>Go Ride</h3>
              <p>
                First, go out on a ride! A great Ride Report doesn't require an epic adventure, just taking the long way
                to work can be a compelling story. Want something epic? Checkout our{" "}
                <a href="/ambassadors">Ambassador Directory</a> or <a href="/ride_reports">Featured Ride Reports</a> for
                some inspiration.
              </p>
            </div>
            <div className={styles.step}>
              <div className={styles.stepNumber}>02</div>
              <div className={styles.stepImage}>
                <img src={`${imagePath}step-2.png`} />
              </div>
              <h3>Record Your Adventure</h3>
              <p>
                You can use your favorite GPS device, but we recommend giving our mobile apps a shot. Our battery life
                is the best in the business, and any pictures you take while riding will automatically be associated
                with your ride. Search iTunes or Google Play for Ride with GPS to get started.
              </p>
            </div>
            <div className={styles.step}>
              <div className={styles.stepNumber}>03</div>
              <div className={styles.stepImage}>
                <img src={`${imagePath}step-3.png`} />
              </div>
              <h3>Take Photos</h3>
              <p>
                Make sure to take plenty of good pictures. If you are using our app, those pictures will automatically
                be associated with your ride. If you are using a standalone GPS unit, or if you are using a DSLR or
                other camera, you can easily upload photos from your computer during the Ride Report creation process.
              </p>
            </div>
            <div className={styles.step}>
              <div className={styles.stepNumber}>04</div>
              <div className={styles.stepImage}>
                <img src={`${imagePath}step-4.png`} />
              </div>
              <h3>Create Your Ride Report</h3>
              <p>
                Once you have recorded a ride, it's time to create your Ride Report. We recommend starting with our fun
                Auto Draft tool. Auto Draft will create an outline of your ride, with a map, climb replay widgets for
                any detected climbs, and plenty of photos. You can easily modify this draft using our powerful editor.
                Once you are done, make sure to publish the report to the Ride Report Rollout Contest!
              </p>
            </div>
          </section>
          <section className={styles.calloutSection}>
            <div className={styles.calloutInner}>
              <h3>We’re here for you with the best customer support in the industry.</h3>
              <div className={styles.calloutButtons}>
                <a href="mailto:info@ridewithgps.com">
                  <Button className={commonStyles.whiteButton}>Talk with Us</Button>
                </a>
                <a href="https://ridewithgps.com/help/ride-reports">
                  <Button className={commonStyles.whiteButton}>Help Center</Button>
                </a>
              </div>
            </div>
          </section>
        </main>
        <GlobalFooter />
      </div>
    );
  }
}
